import {
  Box,
  Paper,
  Typography,
  TextField,
  Button,
  Alert,
  CircularProgress,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  MenuItem,
  Select,
  InputLabel,
  Link,
  Snackbar,
  CardContent,
  Container,
  Card,  
  Slide,
  InputAdornment,
  IconButton,
} from "@mui/material";
import { MuiTelInput } from "mui-tel-input";

import { Link as RouterLink, useLocation, useNavigate } from "react-router-dom";
import React, { useState } from "react";
import { inputHelper } from "../../Helper";
import { useRegisterUserMutation } from "../../Apis/authApi";
import { GOVERNORATES } from "../../Utility/Gov";
import { Visibility, VisibilityOff } from "@mui/icons-material";

let logo2 = require("../../Assets/Images/logoDEC.png");

export default function Register() {
  const [validated, setValidated] = useState(false);
  const [agreed, setAgreed] = useState(false);
  
  const navigate = useNavigate();
  
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const ref = queryParams.get("ref"); 
  const [registerUser] = useRegisterUserMutation();

  const [loading, setLoading] = useState(false);
  const [snackbar, setSnackbar] = useState<{
    open: boolean;
    message: string;
    severity: "success" | "error" | "info";
  }>({ open: false, message: "", severity: "info" });

  const [userInput, setUserInput] = useState({
    name: "",
    userName: "",
    phoneNumber: "",
    password: "",
    confirmPassword: "",
    entity: "",
    role: "",
    job: "",
    otherJob: "",
    governorateId: "",
    countryCode: "+967",
  });
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const handleUserInput = (e: any) => {
    const tempData = inputHelper(e, userInput);
    setUserInput(tempData);
  };

   const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };
   const handleClickShowConfirmPassword = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.stopPropagation();
      setValidated(true);
      return;
    }

    setValidated(true);
    setLoading(true);
    

    try {
      const jobValue =
        userInput.job === "Other" ? userInput.otherJob : userInput.job;
      const payload = {
        userName: userInput.userName,
        fullName: userInput.name,
        password: userInput.password,
        phoneNumber: `${userInput.countryCode}${userInput.phoneNumber}`,
        role: userInput.role,
        entity: userInput.entity,
        job: jobValue,
        governorateId: userInput.governorateId
          ? parseInt(userInput.governorateId as string, 10)
          : null,
        referralProgressId: ref ? Number(ref) : null,
      };

      const response = await registerUser(payload).unwrap();
      setSnackbar({
        open: true,
        message: "Registration successful! Please wait till the admin confirm your registeration login to continue",
        severity: "success",
      });

      navigate("/RegisterConfirm");
    } catch (error: any) {
      if (error.data && error.data.errorMessages) {
        
        setSnackbar({
          open: true,
          message: error.data.errorMessages[0],
          severity: "error",
        });
      }
    } finally {
      setLoading(false);
    }
  };
  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };
  const handlePhoneChange = (value: string) => {
    // value looks like: "+967 777 123 456"

    // extract country code
    const parts = value.split(" ");
    const code = parts[0] || "+967";

    // extract local phone number without spaces
    const number = parts.slice(1).join("").replace(/\s+/g, "");

    setUserInput({
      ...userInput,
      countryCode: code,
      phoneNumber: number,
    });
  };

  // Separate handler for radio buttons
  const handleRadioChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setUserInput({
      ...userInput,
      job: e.target.value,
    });
  };

  return (
    <>
      <Slide direction="right" in={!agreed} timeout={500} unmountOnExit>
        <Box>
          <Container
            maxWidth="md"
            sx={{
              minHeight: "100vh",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              py: 4,
            }}
          >
            <Card sx={{ width: "100%", maxHeight: "100vh", overflowY: "auto" }}>
              <CardContent>
                {/* TITLE + LOGO */}
                <Box sx={{ width: "100%", mb: 2 }}>
                  <Box
                    sx={{
                      display: "grid",
                      gridTemplateColumns: "auto 1fr auto",
                      alignItems: "center",
                      width: "100%",
                    }}
                  >
                    {/* LEFT — LOGO */}
                    <Box
                      component="img"
                      src={logo2}
                      alt="Logo"
                      sx={{
                        height: 35,
                        width: "auto",
                        justifySelf: "start",
                      }}
                    />

                    {/* CENTER — TITLE */}
                    <Typography
                      variant="h6"
                      sx={{
                        color: "rgba(81, 35, 132, 1)",

                        fontWeight: 600,
                        textAlign: "center",
                      }}
                    >
                      Consent Policy
                    </Typography>

                    {/* RIGHT — EMPTY PLACEHOLDER FOR PERFECT CENTERING */}
                    <Box sx={{ width: "Auto" }} />
                  </Box>

                  {/* UNDERLINE */}
                  <Box
                    sx={{
                      mt: 1,
                      width: "100%",
                      height: "1px",
                      backgroundColor: "rgba(81, 35, 132, 1)",
                      borderRadius: 2,
                    }}
                  />
                </Box>

                {/* CONTENT */}
                <Box sx={{ mt: 2 }}>
                  <Typography variant="body2" sx={{ mb: 2 }}>
                    By registering for this Campaign, you acknowledge and
                    provide your consent to Merck Serono Middle East FZ-LLC to
                    communicate with you via email, SMS, phone calls, WhatsApp,
                    social media platforms, and other digital channels to keep
                    you updated with relevant non promotional and promotional
                    information.
                  </Typography>

                  <Typography variant="body2" sx={{ mb: 2 }}>
                    The non-promotional communications are intended to enhance
                    scientific medical education and provide you with multiple
                    sources of data/information and digital tools to better
                    manage chronic diseases and achieve better outcomes, while
                    promotional communications provide updates on our products,
                    services, or events.
                  </Typography>

                  <Typography variant="body2" sx={{ mb: 2 }}>
                    By clicking the button below, you consent to Merck Serono
                    Middle East FZ-LLC sending you email, SMS, WhatsApp, Social
                    Media Messages, Phone Calls, and using other digital
                    channels. Your personal information will be processed
                    securely and in compliance with all relevant regulations.
                  </Typography>

                  <Typography variant="body2" sx={{ mb: 2 }}>
                    You may unsubscribe at any time. For questions or to opt
                    out, contact: medec@merckgroup.com. For adverse event
                    reporting: drug.safety.middleeast@merckgroup.com.
                  </Typography>
                </Box>

                {/* ACTION BUTTONS */}
                <Box
                  sx={{
                    mt: 4,
                    display: "flex",
                    flexDirection: "column",
                    gap: 2,
                  }}
                >
                  <Button
                    onClick={() => setAgreed(true)}
                    sx={{
                      backgroundColor: "#eb3c96",
                      color: "#fff",
                      "&:hover": { backgroundColor: "#d63484" },
                    }}
                  >
                    Agree & Continue
                  </Button>

                  <Button
                    variant="outlined"
                    onClick={() => navigate(-1)}
                    sx={{ borderColor: "#ccc" }}
                  >
                    Cancel
                  </Button>
                </Box>
              </CardContent>
            </Card>
          </Container>
        </Box>
      </Slide>

      <Slide direction="right" in={agreed} timeout={500} unmountOnExit>
        <Box>
          <Box
            sx={{
              minHeight: "100vh",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",

              p: 2,
            }}
          >
            <Paper elevation={4} sx={{ width: "100%", maxWidth: 500, p: 2 }}>
              <Box
                sx={{
                  textAlign: "center",
                  mb: 2,
                  borderBottom: "2px solid rgba(81, 35, 132, 1)",
                }}
              >
                <Box
                  component="img"
                  src={logo2}
                  alt="Logo"
                  sx={{
                    maxHeight: 40,
                    display: "inline-block",
                    pb: 0.5, // small space between image and underline
                  }}
                />
              </Box>

              <Typography
                variant="h5"
                align="left"
                sx={{ mb: 2, fontWeight: 600 }}
              >
                New account
              </Typography>

              <form onSubmit={handleSubmit} noValidate>
                <TextField
                  fullWidth
                  required
                  name="name"
                  label="Full Name"
                  value={userInput.name}
                  onChange={handleUserInput}
                  error={validated && !userInput.name}
                  helperText={
                    validated && !userInput.name
                      ? "Please provide your full name."
                      : ""
                  }
                  sx={{ mb: 2 }}
                />

                <TextField
                  fullWidth
                  required
                  name="userName"
                  label="Email"
                  type="email"
                  value={userInput.userName}
                  onChange={handleUserInput}
                  error={validated && !userInput.userName}
                  helperText={
                    validated && !userInput.userName
                      ? "Please provide a valid email."
                      : ""
                  }
                  sx={{ mb: 2 }}
                />

                <MuiTelInput
                  fullWidth
                  required
                  defaultCountry="YE"
                  value={`${userInput.countryCode}${userInput.phoneNumber}`}
                  onChange={handlePhoneChange}
                  label="Phone Number"
                  sx={{ mb: 2 }}
                  error={validated && !userInput.phoneNumber}
                  helperText={
                    validated && !userInput.phoneNumber
                      ? "Please provide a valid phone number."
                      : ""
                  }
                />

                <TextField
                  fullWidth
                  required
                  label="Password"
                  name="password"
                  type={showPassword ? "text" : "password"}
                  value={userInput.password}
                  onChange={handleUserInput}
                  inputProps={{ minLength: 6 }}
                  error={validated && userInput.password.length < 6}
                  helperText={
                    validated && userInput.password.length < 6
                      ? "Password must be at least 6 characters."
                      : ""
                  }
                  sx={{ mb: 2 }}
                  InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickShowPassword}
                      edge="end"
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
                />

                <TextField
                  fullWidth
                  required
                  label="Confirm Password"
                  name="confirmPassword"
                  type={showConfirmPassword ? "text" : "password"}
                  value={userInput.confirmPassword}
                  onChange={handleUserInput}
                  error={
                    validated &&
                    (userInput.confirmPassword === "" ||
                      userInput.password !== userInput.confirmPassword)
                  }
                  helperText={
                    validated &&
                    (userInput.confirmPassword === "" ||
                      userInput.password !== userInput.confirmPassword)
                      ? "Passwords do not match."
                      : ""
                  }
                  sx={{ mb: 2 }}
                  InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickShowConfirmPassword}
                      edge="end"
                    >
                      {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
                />

                <FormControl fullWidth sx={{ mb: 2 }}>
                  <InputLabel>Governorate / City</InputLabel>
                  <Select
                    name="governorateId"
                    label="Governorate / City"
                    value={userInput.governorateId}
                    required
                    onChange={handleUserInput}
                  >
                    <MenuItem value="">Select Governorate</MenuItem>
                    {GOVERNORATES.map((g) => (
                      <MenuItem key={g.id} value={g.id}>
                        {g.displayName}
                      </MenuItem>
                    ))}
                  </Select>

                  {validated && !userInput.governorateId && (
                    <Typography variant="caption" color="error">
                      Please select a governorate.
                    </Typography>
                  )}
                </FormControl>

                <FormControl component="fieldset" sx={{ mb: 2 }}>
                  <FormLabel>Your Job</FormLabel>
                  <RadioGroup
                    row
                    name="job"
                    value={userInput.job}
                    onChange={handleRadioChange}
                  >
                    <FormControlLabel
                      value="Pharmacist"
                      control={<Radio />}
                      label="Pharmacist"
                    />
                    <FormControlLabel
                      value="Other"
                      control={<Radio />}
                      label="Other"
                    />
                  </RadioGroup>
                </FormControl>

                {userInput.job === "Other" && (
                  <TextField
                    fullWidth
                    required
                    name="otherJob"
                    label="Specify Your Job"
                    value={userInput.otherJob}
                    onChange={handleUserInput}
                    error={validated && !userInput.otherJob}
                    helperText={
                      validated && !userInput.otherJob
                        ? "Please specify your job."
                        : ""
                    }
                    sx={{ mb: 2 }}
                  />
                )}

                <TextField
                  fullWidth
                  required
                  name="entity"
                  label="Entity / Pharmacy"
                  value={userInput.entity}
                  onChange={handleUserInput}
                  error={validated && !userInput.entity}
                  helperText={
                    validated && !userInput.entity
                      ? "Please provide your entity or pharmacy name."
                      : ""
                  }
                  sx={{ mb: 3 }}
                />

                <Button
                  fullWidth
                  type="submit"
                  variant="contained"
                  sx={{
                    py: 1,
                    bgcolor: "#eb3c96",
                    ":hover": { bgcolor: "#d93585" },
                  }}
                  disabled={loading}
                >
                  {loading ? (
                    <CircularProgress size={22} sx={{ color: "#fff" }} />
                  ) : (
                    "Register"
                  )}
                </Button>

                <Typography align="center" sx={{ mt: 2 }}>
                  <Link
                    component={RouterLink}
                    to="/login"
                    sx={{ color: "rgba(81, 35, 132, 1)", fontWeight: 500 }}
                  >
                    Already have an account? Login
                  </Link>
                </Typography>
              </form>
            </Paper>
            <Snackbar
              open={snackbar.open}
              autoHideDuration={5000}
              onClose={handleCloseSnackbar}
              anchorOrigin={{ vertical: "top", horizontal: "center" }}
            >
              <Alert
                onClose={handleCloseSnackbar}
                severity={snackbar.severity}
                sx={{ width: "100%" }}
              >
                {snackbar.message}
              </Alert>
            </Snackbar>
          </Box>
        </Box>
      </Slide>
    </>
  );
}
